import { styled } from 'common/styles'
import Icons from 'common/components/icons'

export const Container = styled('div')`
  border-radius: 0 0.5rem 0.5rem 0;
  position: absolute;
  bottom: 1.5rem;
  background-color: var(--white);
`

export const SignalIcon = styled(Icons)`
  position: absolute;
  left: 1rem;
  top: 0.75rem;
`

export const RemainingTime = styled('span')`
  letter-spacing: 0;
  line-height: 1.25rem;
  color: var(--gray-700);
  font-size: 1rem;
`

export const FormattedDate = styled('span')`
  color: var(--gray-500);
  font-size: 0.875rem;
  letter-spacing: 0;
  line-height: 1.25rem;
`
